// Sharks card game data - ranked by popularity/recognition
export const SHARKS_CARDS = [
  { id: 1, name: "Great White Shark", rank: 1, image: "/images/sharks/sharks_1.jpg" },
  { id: 2, name: "Hammerhead Shark", rank: 2, image: "/images/sharks/sharks_2.jpg" },
  { id: 3, name: "Tiger Shark", rank: 3, image: "/images/sharks/sharks_3.jpg" },
  { id: 4, name: "Whale Shark", rank: 4, image: "/images/sharks/sharks_4.jpg" },
  { id: 5, name: "Bull Shark", rank: 5, image: "/images/sharks/sharks_5.jpg" },
  { id: 6, name: "Mako Shark", rank: 6, image: "/images/sharks/sharks_6.jpg" },
  { id: 7, name: "Blue Shark", rank: 7, image: "/images/sharks/sharks_7.jpg" },
  { id: 8, name: "Nurse Shark", rank: 8, image: "/images/sharks/sharks_8.jpg" },
  { id: 9, name: "Blacktip Shark", rank: 9, image: "/images/sharks/sharks_9.jpg" },
  { id: 10, name: "Lemon Shark", rank: 10, image: "/images/sharks/sharks_10.jpg" },
  { id: 11, name: "Thresher Shark", rank: 11, image: "/images/sharks/sharks_11.jpg" },
  { id: 12, name: "Reef Shark", rank: 12, image: "/images/sharks/sharks_12.jpg" },
  { id: 13, name: "Basking Shark", rank: 13, image: "/images/sharks/sharks_13.jpg" },
  { id: 14, name: "Great Hammerhead", rank: 14, image: "/images/sharks/sharks_14.jpg" },
  { id: 15, name: "Oceanic Whitetip", rank: 15, image: "/images/sharks/sharks_15.jpg" },
  { id: 16, name: "Goblin Shark", rank: 16, image: "/images/sharks/sharks_16.jpg" },
  { id: 17, name: "Leopard Shark", rank: 17, image: "/images/sharks/sharks_17.jpg" },
  { id: 18, name: "Sand Tiger Shark", rank: 18, image: "/images/sharks/sharks_18.jpg" },
  { id: 19, name: "Sandbar Shark", rank: 19, image: "/images/sharks/sharks_19.jpg" },
  { id: 20, name: "Spinner Shark", rank: 20, image: "/images/sharks/sharks_20.jpg" },
  { id: 21, name: "Silky Shark", rank: 21, image: "/images/sharks/sharks_21.jpg" },
  { id: 22, name: "Shortfin Mako", rank: 22, image: "/images/sharks/sharks_22.jpg" },
  { id: 23, name: "Porbeagle Shark", rank: 23, image: "/images/sharks/sharks_23.jpg" },
  { id: 24, name: "Cookiecutter Shark", rank: 24, image: "/images/sharks/sharks_24.jpg" },
  { id: 25, name: "Greenland Shark", rank: 25, image: "/images/sharks/sharks_25.jpg" },
  { id: 26, name: "Megamouth Shark", rank: 26, image: "/images/sharks/sharks_26.jpg" },
  { id: 27, name: "Angel Shark", rank: 27, image: "/images/sharks/sharks_27.jpg" },
  { id: 28, name: "Zebra Shark", rank: 28, image: "/images/sharks/sharks_28.jpg" },
  { id: 29, name: "Wobbegong Shark", rank: 29, image: "/images/sharks/sharks_29.jpg" },
  { id: 30, name: "Sawshark", rank: 30, image: "/images/sharks/sharks_30.jpg" }
];
